import React, { Component } from "react";
import "./Header.css";
import { Link } from "react-router-dom";
import PhoneIcon from "react-icons/lib/fa/phone";
import FaEnvelope from "react-icons/lib/fa/envelope";
import FaArrowCircleORight from "react-icons/lib/fa/arrow-circle-o-right";
import FaAngleDown from "react-icons/lib/fa/angle-down";
import Hamburger from "../Hamburger";
import Logo from "../Svgs/Logo";
import { openPolicySearchModal } from "../../actions/policies";
import PolicySearchModal from "../PolicySearchModal/PolicySearchModal";

import { getTranslate } from "react-localize-redux";
import { connect } from "react-redux";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import FaSearch from "react-icons/lib/fa/search";
import { getActiveLanguage } from "react-localize-redux";

import LanguageMobile from "./LanguageMobile";
import api from "../../api/index";
import { AGENTS_URL } from "../../config";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPath: "",
    };
  }

  handleHamburger = () => {
    var menu = document.getElementById("mobileMenu");
    menu.classList.toggle("mobileMenuHeight");

    const html = document.getElementById("html");
    html.classList.toggle("noscroll");
  };

  handleScrollOn = () => {
    document.getElementById("html").classList.remove("noscroll");
  };

  handleScroll = () => {
    const header = document.getElementById("header");
    const nav = document.getElementById("nav");
    const breadcrumbs = document.getElementById("breadcrumbs");
    const logo = document.getElementById("main-logo");
    if (window.scrollY > nav.offsetTop) {
      if (!header.classList.contains("headerHeight")) {
        header.classList.add("headerHeight");
        logo.classList.add("logo-width");
      }
      if (!nav.classList.contains("navHeight")) {
        nav.classList.add("navHeight");
      }
      if (breadcrumbs) {
        if (!breadcrumbs.classList.contains("breadcrumbsHeight")) {
          breadcrumbs.classList.add("breadcrumbsHeight");
        }
      }
    } else {
      header.classList.remove("headerHeight");
      nav.classList.remove("navHeight");
      logo.classList.remove("logo-width");
      if (breadcrumbs) {
        if (breadcrumbs.classList.contains("breadcrumbsHeight")) {
          breadcrumbs.classList.remove("breadcrumbsHeight");
        }
      }
    }
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  onAgents = () => {
    window.open(`${window.config.env.EXTERNAL_LINKS}`);
  };

  render() {
    const { translate, currentLocale } = this.props;
    return (
      <header className="header" id="header">
        <div className="headerContent">
          <div className="logo mobileLogo">
            <Link to="/">
              {" "}
              <Logo width={100} />{" "}
            </Link>
          </div>
          <div className="header-items">
            <div className="header-item" id="header-item">
              <div className="phoneContainer" onClick={this.handlePhoneClick}>
                <a href="tel:+995322301111">
                  <PhoneIcon className="phone" />
                </a>
              </div>
              <a href="tel:+995322301111">+995 322 301111</a>
            </div>
            <div className="header-item">
              <div className="envelope">
                <FaEnvelope className="envelope" />
              </div>
              info@tpl.ge
            </div>
            <div
              className="header-item agent-item caps"
              onClick={this.onAgents}
            >
              {translate("byAgents")}{" "}
              <FaArrowCircleORight className="arrowCircle" />
            </div>
            <div
              className="header-item SearchMobile"
              onClick={() => {
                this.props.dispatch(openPolicySearchModal(true));
              }}
            >
              <FaSearch />
            </div>
            <LanguageMobile />
            <Hamburger handleHamburger={this.handleHamburger} />
          </div>
          <div className="header-items dropdown">
            <LanguageSwitcher />
          </div>
        </div>
        <div className="mobileMenu" id="mobileMenu">
          <ul className="mobileMenu-items">
            <li className="mobileMenu-item" onClick={this.handleScrollOn}>
              <Link to="/">{translate("main")}</Link>
            </li>
            <li className="mobileMenu-item" onClick={this.handleScrollOn}>
              <Link
                to={
                  "/" +
                  currentLocale.code +
                  "/" +
                  translate("termsandconditionsUrl")
                }
              >
                {" "}
                {translate("termsandconditions")}
              </Link>
            </li>
            <li className="mobileMenu-item" onClick={this.handleScrollOn}>
              <Link
                to={
                  "/" + currentLocale.code + "/" + translate("salespointsUrl")
                }
              >
                {translate("salespoints")}
              </Link>
            </li>
            <li className="mobileMenu-item" onClick={this.handleScrollOn}>
              <Link
                to={"/" + currentLocale.code + "/" + translate("aboutusUrl")}
              >
                {" "}
                {translate("aboutus")}
              </Link>
            </li>
            <li className="mobileMenu-item" onClick={this.handleScrollOn}>
              <Link to={"/" + currentLocale.code + "/" + translate("faqUrl")}>
                {" "}
                {translate("faq")}
              </Link>
            </li>
            <li className="mobileMenu-item" onClick={this.handleScrollOn}>
              <Link
                to={"/" + currentLocale.code + "/" + translate("contactusUrl")}
              >
                {" "}
                {translate("contact")}
              </Link>
            </li>
          </ul>
          <div className="mobileMenuFooter">
            <div className="logo mobileLogo">
              <Link to="/">
                <Logo width={100} />
              </Link>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

const mapStateToProps = (state) => ({
  translate: getTranslate(state.locale),
  currentLocale: getActiveLanguage(state.locale),
});
export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js